import React from 'react';
import { Card } from '@/components/ui/card';

interface StatCardProps {
  label: string;
  value: number | string;
}

/** `variant="outlined"` in MUI: a border and no elevation, hence shadow-none. */
const StatCard: React.FC<StatCardProps> = ({ label, value }) => (
  <Card className="shadow-none">
    <div className="p-4">
      <p className="revy-cjk text-xs leading-[1.7] text-muted-foreground">{label}</p>
      <h4 className="revy-figure text-2xl font-medium leading-[1.4]">{value}</h4>
    </div>
  </Card>
);

export default StatCard;
